

















import {Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CircleCountdown extends Vue {

    @Prop({ default: 5000 }) delay: number;

    progress = 100
    circumference = 0;
    rad = 10;
    isOnReset = false;

    mounted() {
        this.circumference = Math.PI*(this.rad*2);
        setTimeout(() => {
            this.reset();
        }, 20)
    }

    get transitionStyle() {
        return this.isOnReset ? 'none' : ` stroke-dashoffset ${this.delay / 1000}s linear;`
    }

    get offset() {
        return this.circumference - this.progress / 100 * this.circumference
    }

    reset() {
        this.isOnReset = true;
        this.progress = 100;

        this.$nextTick(() => {
            this.isOnReset = false

            this.$nextTick(() => {
                this.update();
            })
        })
    }

    update() {
        if(this.progress >= 100) {
            this.progress = 0;
        }
        else {
            this.progress = 100
        }
    }
}
